import React from 'react';
import { Card, CardBody, CardHeader, CardHeaderBtn } from './../../components/card/card.jsx';

function LayoutStarter() {
	return (
		<div>
			<ul className="breadcrumb">
				<li className="breadcrumb-item"><a href="#/">LAYOUT</a></li>
				<li className="breadcrumb-item active">STARTER PAGE</li>
			</ul>
		
			<h1 className="page-header">
				Starter Page <small>page header description goes here...</small>
			</h1>
		
			<Card>
				<CardHeader className="with-btn">
					CARD HEADER
					<CardHeaderBtn />
				</CardHeader>
				<CardBody>
					<p>
						Start build your page here
					</p>
				</CardBody>
			</Card>
		</div>
	)
}

export default LayoutStarter;